import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
const { createSlice } = require("@reduxjs/toolkit");
var tempObj = {
  actual_price: "75",
  is_discount: "No",
  is_for_whole_order: "No",
  id: "224931dd-1106-4057-930d-9f6b07749d34",
  price: 75,
  quantity: "1",
  name: {
    en: "Room4",
    ar: "بركر",
  },
  single_item_name: "",
  single_item_price: 75,
  single_options: null,
  multiple_option: [],
  description: {
    en: "",
    ar: "",
  },
  color_size: null,
  affiliation: "Direct",
  item_brand: "test-resto",
  item_category: "",
  item_category2: "",
  item_category3: "",
  item_category4: "",
  item_category5: "",
};

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
    // dukanyCartItems:[],
  },
  reducers: {
    addToCart(state, action) {
      const product = action.payload;
      console.log(product);
      if (!product.variation) {
        const cartItem = state.cartItems.find((item) => item.id === product.id);
        if (!cartItem) {
          state.cartItems.push({
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuidv4(),
          });
        } else {
          state.cartItems = state.cartItems.map((item) => {
            if (item.cartItemId === cartItem.cartItemId) {
              return {
                ...item,
                quantity: product.quantity
                  ? item.quantity + product.quantity
                  : item.quantity + 1,
              };
            }
            return item;
          });
        }
      } else {
        const cartItem = state.cartItems.find(
          (item) =>
            item.id === product.id &&
            // product.selectedProductColor &&
            // product.selectedProductColor === item.selectedProductColor &&
            // product.selectedProductSize &&
            // product.selectedProductSize === item.selectedProductSize &&
            (product.cartItemId ? product.cartItemId === item.cartItemId : true)
        );
        state.cartItems.push({
          ...product,
          quantity: product.quantity ? product.quantity : 1,
          cartItemId: uuidv4(),
        });
        // if (!cartItem) {
        //   state.cartItems.push({
        //     ...product,
        //     quantity: product.quantity ? product.quantity : 1,
        //     cartItemId: uuidv4(),
        //   });
        // }
        // else if (
        //   cartItem !== undefined &&
        //   (cartItem.selectedProductColor !== product.selectedProductColor ||
        //     cartItem.selectedProductSize !== product.selectedProductSize)
        // ) {
        //   state.cartItems = [
        //     ...state.cartItems,
        //     {
        //       ...product,
        //       quantity: product.quantity ? product.quantity : 1,
        //       cartItemId: uuidv4(),
        //     },
        //   ];
        // }
        // else {
        //   state.cartItems = state.cartItems.map((item) => {
        //     if (item.cartItemId === cartItem.cartItemId) {
        //       return {
        //         ...item,
        //         quantity: product.quantity
        //           ? item.quantity + product.quantity
        //           : item.quantity + 1,
        //         selectedProductColor: product.selectedProductColor,
        //         selectedProductSize: product.selectedProductSize,
        //       };
        //     }
        //     return item;
        //   });
        // }
      }

      toast.success("Added To Cart", { position: "bottom-left" });
    },
    deleteFromCart(state, action) {
      state.cartItems = state.cartItems.filter(
        (item) => item.cartItemId !== action.payload
      );
      toast.error("Removed From Cart", { position: "bottom-left" });
    },
    decreaseQuantity(state, action) {
      const product = action.payload;
      if (product.quantity === 1) {
        state.cartItems = state.cartItems.filter(
          (item) => item.cartItemId !== product.cartItemId
        );
        toast.error("Removed From Cart", { position: "bottom-left" });
      } else {
        state.cartItems = state.cartItems.map((item) =>
          item.cartItemId === product.cartItemId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
        toast.warn("Item Decremented From Cart", { position: "bottom-left" });
      }
    },
    deleteAllFromCart(state) {
      state.cartItems = [];
      localStorage.removeItem("abandonedCartSSID");
    },
  },
});

export const {
  addToCart,
  deleteFromCart,
  decreaseQuantity,
  deleteAllFromCart,
} = cartSlice.actions;
export default cartSlice.reducer;
